export default function TestimonialSection() {
  const testimonials = [
    {
      name: 'Marcus Chen',
      handle: '@marcusdropship',
      avatar: 'M',
      text: 'The AllChinaBuySpreadsheet completely changed how I find products. Instead of spending 15 hours a week on 1688, I now spend maybe 2 hours and my product hit rate has doubled. Made my first $10K month three months after switching.',
    },
    {
      name: 'Sarah Okafor',
      handle: '@sarahecomcoach',
      avatar: 'S',
      text: 'I was skeptical about spreadsheets vs agents, but the structure and weekly updates won me over. The category organization alone saved me from analysis paralysis. Highly recommend for anyone serious about ecommerce.',
    },
    {
      name: 'James Wainwright',
      handle: '@jamesw_shop',
      avatar: 'J',
      text: 'Been sourcing from China for 4 years and AllChinaBuySpreadsheet is hands down the most efficient tool I have used. The supplier verification notes alone are worth it — caught two sketchy suppliers before placing orders.',
    },
    {
      name: 'Priya Mehta',
      handle: '@priyasells',
      avatar: 'P',
      text: 'As a TikTok Shop seller, speed is everything. AllChinaBuySpreadsheet helps me spot trends early and get products listed before saturation hits. The trending section is my secret weapon for viral product launches.',
    },
    {
      name: 'Diego Ramirez',
      handle: '@diego_imports',
      avatar: 'D',
      text: 'Switched from using an agent to the spreadsheet and my margins improved by 18% in the first quarter. No middleman markup means more profit per sale. The learning curve is minimal — even my assistant figured it out in a day.',
    },
    {
      name: 'Emma Lindqvist',
      handle: '@emmanordic',
      avatar: 'E',
      text: 'What sets AllChinaBuySpreadsheet apart is the organization. Everything is categorized, priced, and ranked. I used to keep 30 browser tabs open — now everything is in one clean file. A no-brainer for organized sellers.',
    },
  ];

  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 border border-accent-300/60 rounded-full text-sm font-medium text-accent-700 bg-accent-100/80 mb-6 whitespace-nowrap">
            Verified Reviews
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Real Sellers.
            <br />
            Real Results.
          </h2>
          <p className="text-base text-foreground-600 max-w-xl leading-relaxed">
            See what real ecommerce sellers say about how the AllChinaBuySpreadsheet helped them
            find winning products and grow their online stores.
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="break-inside-avoid bg-background-50 rounded-xl p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-heading text-base font-bold text-accent-600">{t.avatar}</span>
                </div>
                <div>
                  <p className="font-heading text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.handle}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">&ldquo;{t.text}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}